// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__30fVE","info":"UpdateTermsInfo_info__2PvOY"};